let apiBase = {
  queryPDFMenuTree:'/api/pdfMenu/queryTreeList',//PDF导航列表
  queryPDFMenuDetail:'/api/pdfMenu/queryDetail',//PDF导航详情
  addPDFMenu:'/api/pdfMenu/add',//PDF导航新增
  updatePDFMenu:'/api/pdfMenu/update',//PDF导航更新
  deletePDFMenu:'/api/pdfMenu/delete',//PDF导航删除
  
  queryPDFCenterList:'/api/pdfCenter/queryPage',//PDF中心列表
  addPDFCenter:'/api/pdfCenter/add',//PDF中心新增
  queryPDFCenterDetail:'/api/pdfCenter/queryDetail',//PDF中心详情
  updatePDFCenter:'/api/pdfCenter/update',//PDF中心更新
  publishPDFCenter:'/api/pdfCenter/publish',//PDF中心发布
  offShelfPDFCenter:'/api/pdfCenter/offShelf',//PDF中心下架
  
  

}
let DocumentPDFServerObject = null
class DocumentPDFServer{
  constructor(){}
  queryPDFMenuTree(data={}){
    return $http({
      url: apiBase.queryPDFMenuTree,
      method: 'post',
      data: data,
    })
  }
  queryPDFMenuDetail(data={}){
    return $http({
      url: apiBase.queryPDFMenuDetail,
      method: 'post',
      data: data,
    })
  }
  addPDFMenu(data={}){
    return $http({
      url: apiBase.addPDFMenu,
      method: 'post',
      data: data,
    })
  }
  updatePDFMenu(data={}){
    return $http({
      url: apiBase.updatePDFMenu,
      method: 'post',
      data: data,
    })
  }
  deletePDFMenu(data={}){
    return $http({
      url: apiBase.deletePDFMenu,
      method: 'post',
      data: data,
    })
  }







  queryPDFCenterList(data={}){
    return $http({
      url: apiBase.queryPDFCenterList,
      method: 'post',
      data: data,
    })
  }


  addPDFCenter(data={}){
    return $http({
      url: apiBase.addPDFCenter,
      method: 'post',
      data: data,
    })
  }
  queryPDFCenterDetail(data={}){
    return $http({
      url: apiBase.queryPDFCenterDetail,
      method: 'post',
      data: data,
    })
  }
  updatePDFCenter(data={}){
    return $http({
      url: apiBase.updatePDFCenter,
      method: 'post',
      data: data,
    })
  }
  publishPDFCenter(data={}){
    return $http({
      url: apiBase.publishPDFCenter,
      method: 'post',
      data: data,
    })
  }
  offShelfPDFCenter(data={}){
    return $http({
      url: apiBase.offShelfPDFCenter,
      method: 'post',
      data: data,
    })
  }

}
function singlDocumentPDFServer(){
  if(DocumentPDFServerObject === null){
    DocumentPDFServerObject = new DocumentPDFServer()
  }
  return DocumentPDFServerObject
}
export default singlDocumentPDFServer()